'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
import { useRouter, usePathname } from 'next/navigation';

/**
 * View mode management hook
 * Handles view mode switching (map/list)
 * Updates URL to preserve browser history for back navigation
 */

export function useExploreView(state, dispatch, buildUrlParamsFromFilters, initialMarkers) {
  const $ = _c(10);
  const router = useRouter();
  const pathname = usePathname();
  const currentParamsRef = useRef("");
  let t0;
  if ($[0] !== buildUrlParamsFromFilters || $[1] !== dispatch || $[2] !== initialMarkers || $[3] !== pathname || $[4] !== router || $[5] !== state.filters) {
    t0 = (mode, t1) => {
      const {
        syncUrl: t2
      } = t1 === undefined ? {} : t1;
      const syncUrl = t2 === undefined ? true : t2;
      dispatch({
        type: "SET_VIEW_MODE",
        payload: mode
      });
      if (!syncUrl) {
        return;
      }
      const filterParams = buildUrlParamsFromFilters(state.filters, initialMarkers);
      if (mode === "map") {
        const hasOtherParams = filterParams.toString().length > 0;
        if (hasOtherParams) {
          filterParams.set("view", "map");
        }
      } else {
        filterParams.set("view", mode);
      }
      const newUrl = filterParams.toString() ? `${pathname}?${filterParams.toString()}` : pathname;
      currentParamsRef.current = filterParams.toString();
      router.replace(newUrl, {
        scroll: false
      });
    };
    $[0] = buildUrlParamsFromFilters;
    $[1] = dispatch;
    $[2] = initialMarkers;
    $[3] = pathname;
    $[4] = router;
    $[5] = state.filters;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const setViewMode = t0;
  let t1;
  if ($[7] !== setViewMode || $[8] !== state.viewMode) {
    t1 = {
      viewMode: state.viewMode,
      setViewMode
    };
    $[7] = setViewMode;
    $[8] = state.viewMode;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}